import { Pipe, PipeTransform } from '@angular/core';
import { MasterMilestoneCalendarTypeEnum } from '@zaoblako/shared/modules/report/dtos/event-calendar/enums/master.milestone.calendar.type.enum';

const masterMilestoneCalendarTypeNames: Record<MasterMilestoneCalendarTypeEnum, string> = {
  [MasterMilestoneCalendarTypeEnum.PROJECT]: 'pi pi-clock',
  [MasterMilestoneCalendarTypeEnum.PROJECT_CHECKLIST]: 'pi pi-check-square',
  [MasterMilestoneCalendarTypeEnum.HELPDESK]: 'pi pi-question-circle',
  [MasterMilestoneCalendarTypeEnum.DEAL_EVENT]: 'pi pi-briefcase',
  [MasterMilestoneCalendarTypeEnum.TASK_PAYMENT]: 'pi pi-dollar'
};

@Pipe({
  name: 'masterMilestoneCalendarTypeIcon',
  standalone: true
})
export class MasterMilestoneCalendarTypeIconPipe implements PipeTransform {
  public transform(type: MasterMilestoneCalendarTypeEnum): string {
    return masterMilestoneCalendarTypeNames[type] || '';
  }
}
